import React, { useState } from "react";

// Utility function to clear access (can be used for logout functionality)
export const clearAiSdrAccess = () => {
  localStorage.removeItem("ai-sdr-access");
};

const AccessCodePopup = ({ onAccess }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.toLowerCase() === "reworld") {
      // Store access granted in localStorage to persist across refreshes
      localStorage.setItem("ai-sdr-access", "granted");
      onAccess();
    } else {
      setError("Invalid access code. Please try again.");
      setCode("");
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">
          AI-SDR Access
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label
              htmlFor="accessCode"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Enter Access Code
            </label>
            <input
              type="text"
              id="accessCode"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Enter your access code"
              autoFocus
            />
            {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
          </div>

          <button
            type="submit"
            className="w-full bg-purple-600 text-white py-2 px-4 rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccessCodePopup;
